module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/cup/2-a57696d5e2f53040eb928b78a0f43e5b.jpg";